<div class="main-nav printMe">
  <mat-nav-list *ngIf="navLinks" (click)="onCloseSidenav()">
    <mat-accordion>
      <ul>
        <ng-container *ngFor="let item of navItems">
          <li [routerLink]="[item.route]" routerLinkActive="router-link-active" *ngIf="item.icon !== 'faSyncAlt'">
            <ng-container [ngSwitch]="item.icon">
              <fa-icon *ngSwitchCase="'faChartPie'" [icon]="faChartPie"></fa-icon>
              <fa-icon *ngSwitchCase="'faUser'" [icon]="faUser"></fa-icon>
              <fa-icon *ngSwitchCase="'faClipBoardList'" [icon]="faClipBoardList"></fa-icon>
              <fa-icon *ngSwitchCase="'faTruck'" [icon]="faTruck"></fa-icon>
            </ng-container>
            {{item.name}}
          </li>
          <li  *ngIf="item.icon === 'faSyncAlt'" (click)="openDialogDeleteRecords()" >
              <fa-icon [icon]="faSyncAlt"></fa-icon>
            {{item.name}}
          </li>
        </ng-container>
      </ul>
      <!-- <app-nav-item *ngFor=" let link of navLinks" [link]="link">
          </app-nav-item> -->
    </mat-accordion>
  </mat-nav-list>

  <mat-list class="version">
    <mat-list-item>
      Développé par la société
    </mat-list-item>
    <mat-list-item>
      <a href="https://www.bizzdev.com/" target="_blank">
        <img src="/assets/icons/bizzdev_w.png" alt="Logo Bizzdev" width="44" height="28">
      </a>
      version: {{appVersion}}
    </mat-list-item>
    <mat-list-item *ngIf="isLocalTranslations" class="local-translation">
      - Local Translations: ON -
    </mat-list-item>
  </mat-list>
</div>